module.exports = __webpack_public_path__ + "static/media/rec.f1243246.png";